export default {"src":"/_next/static/media/supplier_and_risk_analytics.a6b1986e.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};